import repository from '@/services/repository';

const resource = '/MeasuringStates';

export default {
    lookup(options: any, start: Date, end: Date, includeAll: boolean, searchValue: string) {
        const formData = new FormData();

        for ( const key in options ) {
            if (options.hasOwnProperty(key)) {
                formData.append(key, JSON.stringify(options[key]));
            }
        }

        return repository
            .post(`${resource}/GetMeasuringStateForAgendaOverview?start=${start.toISOString()}`
                + `&end=${end.toISOString()}&includeAll=${includeAll}&searchValue=${searchValue}`,
                formData,
                {
                    headers: {'Content-Type': 'multipart/form-data' },
                });
    }
};
